<template>
  <v-container>
    <h3>タイル表示設定</h3>

    <v-row class="mt-8 mb-5">

      <v-col cols="12" v-for="(tile, index) in tiles" v-bind:key="tile.key">
        <v-card variant="outlined" elevation="1">
          <v-card-text>
            <v-row>
              <v-col :cols="$vuetify.display.mobile ? 5 : 2" class="d-flex align-center">
                <v-label class="text-subtitle-2">モジュール</v-label>
              </v-col>
              <v-col :cols="$vuetify.display.mobile ? 7 : 10">
                <span class="ms-1 text-subtitle-1">{{ tile.moduleID }}</span>
              </v-col>

              <v-col :cols="$vuetify.display.mobile ? 12 : 2">
                <v-label class="text-subtitle-2">チャンネル</v-label>
              </v-col>
              <v-col :cols="$vuetify.display.mobile ? 12 : 10">
                <span class="ms-1 text-subtitle-1">
                  {{ (tile.moduleID in browsableChannelsMap) ? browsableChannelsMap[tile.moduleID].channels[tile.ch].name : '' }}
                </span>
              </v-col>

              <v-divider class="mt-2"></v-divider>
            </v-row>
          </v-card-text>

          <v-card-actions class="d-flex justify-space-between">
            <div>
              <v-btn icon="mdi-arrow-up" size="small" v-bind:class="{ 'v-hidden': index === 0 }"
                v-on:click="upDisplayOrder(index);"></v-btn>
              <v-btn icon="mdi-arrow-down" size="small" v-bind:class="{ 'v-hidden': index === (tiles.length - 1) }"
                v-on:click="downDisplayOrder(index);"></v-btn>
            </div>

            <v-btn icon="mdi-delete" size="small" color="error" v-on:click="deleteTile(index);"></v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" class="d-flex justify-center" v-if="tiles.length < 60">
        <v-btn elevation="1" prepend-icon="mdi-plus" v-on:click="showChannelSelectDialog">
          タイルを追加
        </v-btn>
      </v-col>

    </v-row>

    <v-dialog persistent max-width="800" v-model="isShowChannelSelectDialog">
      <v-card height="100dvh">
        <v-card-item>
          <v-card-title>表示タイル追加</v-card-title>
        </v-card-item>

        <v-card-text class="mt-3">
          <v-form @submit.prevent ref="form">
            <v-row>
              <v-col :cols="$vuetify.display.mobile ? 12 : 5">
                <v-label class="mb-3">モジュール選択</v-label>
                <v-select density="compact"
                  :rules="[ v => (v !== '') || '必須' ]"
                  persistent-hint hint="必須"
                  v-model:model-value="moduleID" @update:model-value="setupChannelSelect"
                  :items="browsableModules"></v-select>
              </v-col>

              <v-col cols="12">
                <v-label class="mb-3">チャンネル選択</v-label>
                <v-select density="compact"
                  :rules="[ v => (v !== '') || '必須' ]"
                  persistent-hint hint="必須"
                  v-model:model-value="channelKey"
                  :items="channels"></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="pa-5 d-flex justify-end">
          <v-btn variant="outlined" v-on:click="isShowChannelSelectDialog = false;">キャンセル</v-btn>
          <v-btn variant="flat" color="primary" v-on:click="addTile">追加</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { defineComponent, ref, onMounted } from 'vue';

import axios from 'axios';

import config from '@/config.js';

export default defineComponent({
  name: 'TileViewSetting',

  setup() {

    const tiles = ref([]);

    const browsableChannelsMap = ref({});


    const isShowChannelSelectDialog = ref(false);

    const form = ref();

    const moduleID = ref('');
    const browsableModules = ref([
      { title: '未選択', value: '' }
    ]);

    const channelKey = ref('');
    const channels = ref([
      { title: '未選択', value: '' }
    ]);


    onMounted(() => {

      const tilesSetting = window.localStorage.getItem('tiles-setting');
      if (tilesSetting != null) {
        tiles.value = JSON.parse(tilesSetting);
      }

      fetchBrowsableChannels();

    });

    const fetchBrowsableChannels = () => {

      axios.get(
        config.API_URL +
        `/users/me`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem("access-token") } }
      ).then((response) => {

        response.data.browsableModules.forEach((moduleID) => {

          browsableModules.value.push({
            title: moduleID,
            value: moduleID
          });

          fetchChannelList(moduleID);

        });

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };

    const fetchChannelList = (moduleID) => {

      axios.get(
        config.API_URL +
        `/modules/${ moduleID }/channels`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem('access-token') } }
      ).then((response) => {

        browsableChannelsMap.value[moduleID] = {
          channels: {}
        };

        for (let key in response.data.channels) {

          let generalName;

          if (key.startsWith('a')) {
            generalName = 'アナログ' + key.substring(1);
          }
          else if (key.startsWith('do')) {
            generalName = 'デジタル出力' + key.substring(2);
          }
          else {
            generalName = 'デジタル入力' + key.substring(1);
          }

          generalName = '（' + generalName + '）';

          browsableChannelsMap.value[moduleID].channels[key] = {
            name: generalName + response.data.channels[key].name
          };

        }

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };


    const showChannelSelectDialog = () => {

      moduleID.value = '';

      setupChannelSelect();

      isShowChannelSelectDialog.value = true;

    };

    const setupChannelSelect = () => {

      channelKey.value = '';

      channels.value = [
        { title: '未選択', value: '' }
      ];

      if (moduleID.value !== '') {
        for (let key in browsableChannelsMap.value[moduleID.value].channels) {

          channels.value.push({
            title: browsableChannelsMap.value[moduleID.value].channels[key].name,
            value: key
          });

        }
      }

    };

    const addTile = async () => {

      const { valid } = await form.value.validate();
      if (!valid) {
        return;
      }

      tiles.value.push({
        key: crypto.randomUUID(),

        moduleID: moduleID.value,
        ch: channelKey.value
      });

      saveToLocalStorage();

      isShowChannelSelectDialog.value = false;

    };


    const upDisplayOrder = (index) => {

      const tmp = tiles.value[index - 1];
      tiles.value[index - 1] = tiles.value[index];
      tiles.value[index] = tmp;

      saveToLocalStorage();

    };

    const downDisplayOrder = (index) => {

      const tmp = tiles.value[index + 1];
      tiles.value[index + 1] = tiles.value[index];
      tiles.value[index] = tmp;

      saveToLocalStorage();

    };

    const deleteTile = (index) => {

      tiles.value.splice(index, 1);

      saveToLocalStorage();

    };


    const saveToLocalStorage = () => {

      window.localStorage.setItem('tiles-setting', JSON.stringify(tiles.value));

    };


    return {
      tiles,

      browsableChannelsMap,


      isShowChannelSelectDialog,

      form,

      moduleID,
      browsableModules,

      channelKey,
      channels,


      showChannelSelectDialog,
      setupChannelSelect,
      addTile,

      upDisplayOrder,
      downDisplayOrder,
      deleteTile
    }

  }
});
</script>
